export enum OffsetType {
    VERTEX = "VERTEX",
    INDEX = "INDEX",
    STRING = "STRING",
    KEY = "KEY",
}
